export default __webpack_public_path__ + "static/media/react.1f39136a.svg";